/** Règlement du jeu (PDF hébergé). */
export const REGLEMENT_JEU_PDF_URL =
  "https://oxoformdocs.fra1.digitaloceanspaces.com/693acc404bf8fe2177e79a2b/Reglement.pdf";

/** Mentions légales (PDF hébergé). */
export const MENTIONS_LEGALES_URL =
  "https://oxoformdocs.fra1.digitaloceanspaces.com/693acc404bf8fe2177e79a2b/modalites.pdf";

/** Politique de confidentialité (PDF hébergé). */
export const POLITIQUE_CONFIDENTIALITE_URL =
  "https://oxoformdocs.fra1.digitaloceanspaces.com/693acc404bf8fe2177e79a2b/politique.pdf";
